/* eslint-disable react/jsx-max-props-per-line */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Grid, Stack, Typography } from '@mui/material';
import {
  ArquivoContainerV2,
  DialogDefaultV2,
} from '../../../../components/v2';
import * as selectorsNsmp from '../../../../store/nsmp/reducer';
import * as actionsNsmp from '../../../../store/nsmp/actions';
import {
  formatEvidenciaGpsCaption,
  isArquivoCarimbada,
} from '../utils/arquivoAdditions';

const rootGridSx = { pt: 1 };

const buildCarouselHeaderActions = ({
  carouselPosition,
  onPrevious,
  onNext,
  hasPrevious,
  hasNext,
}) => {
  if (!carouselPosition) return null;
  return [
    { title: '◄', onClick: onPrevious, disabled: !hasPrevious },
    {
      title: `${carouselPosition.current} / ${carouselPosition.total}`,
      onClick: () => {},
      disabled: true,
    },
    { title: '►', onClick: onNext, disabled: !hasNext },
  ];
};

const UsoMutuoEvidenciaCampoModal = ({
  open,
  onCancel,
  selectedId,
  nsmpSelected,
  loadNsmpById,
  nsirTitle,
  onNext,
  onPrevious,
  hasNext,
  hasPrevious,
  carouselPosition,
}) => {
  const [values, setValues] = useState({ fotos: [] });

  useEffect(() => {
    if (selectedId) loadNsmpById(selectedId);
  }, [selectedId, loadNsmpById]);

  useEffect(() => {
    if (nsmpSelected && nsmpSelected.id) {
      setValues(nsmpSelected);
    }
  }, [nsmpSelected]);

  const onCancelLocal = () => {
    setValues({ fotos: [] });
    onCancel();
  };

  const getTitle = () => {
    const codigo = values?.codigo ? ` ${values.codigo}` : '';
    return `${nsirTitle} > Evidência de campo${codigo}`;
  };

  const fotos = values.fotos || [];

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onCancelLocal}
      handlerConfirm={onCancelLocal}
      title={getTitle()}
      confirmMessage="Fechar"
      maxWidth="lg"
      fullWidth
      readOnly
      headerAction={buildCarouselHeaderActions({
        carouselPosition,
        onPrevious,
        onNext,
        hasPrevious,
        hasNext,
      })}
    >
      <Grid container spacing={1} sx={rootGridSx}>
        <Grid size={{ xs: 12 }}>
          <ArquivoContainerV2
            arquivos={fotos}
            showDescription
            disabled
            onSave={() => {}}
          />
        </Grid>
        {fotos.map((foto) => {
          const gps = formatEvidenciaGpsCaption(foto.additions);
          const carimbada = isArquivoCarimbada(foto.additions);
          if (!gps && !carimbada) return null;
          return (
            <Grid key={foto.id || foto.externalId || foto.nome} size={{ xs: 12 }}>
              <Stack spacing={0.25}>
                <Typography variant="caption" fontWeight={700}>
                  {foto.nome || 'Foto'}
                </Typography>
                {gps && (
                  <Typography variant="caption" color="text.secondary">
                    {gps}
                  </Typography>
                )}
                {carimbada && (
                  <Typography variant="caption" color="text.secondary">
                    Localização já carimbada na imagem
                  </Typography>
                )}
              </Stack>
            </Grid>
          );
        })}
      </Grid>
    </DialogDefaultV2>
  );
};

UsoMutuoEvidenciaCampoModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedId: PropTypes.string,
  nsmpSelected: PropTypes.object,
  loadNsmpById: PropTypes.func.isRequired,
  nsirTitle: PropTypes.string.isRequired,
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  hasNext: PropTypes.bool,
  hasPrevious: PropTypes.bool,
  carouselPosition: PropTypes.object,
};

UsoMutuoEvidenciaCampoModal.defaultProps = {
  selectedId: undefined,
  nsmpSelected: {},
};

const mapStateToProps = (state) => ({
  nsmpSelected: selectorsNsmp.getNsmpSelected(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...actionsNsmp }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UsoMutuoEvidenciaCampoModal);
